import React from 'react';
import { RootStore, UserStore, AddressesStore, CCStore } from 'AppClient/stores';
import { inject, observer } from 'mobx-react';
import { Form, Modal, Button } from 'components/antd';
import UserProfileForm from './UserProfileForm';
import { FormComponentProps } from 'antd/lib/form';
import { hasErrors, removeEmptyProperties } from 'utils/utils';
import { FORM_STRUCTURE, UpdateUserProfile } from 'AppClient/api/UserProfile';

import styles from './styles.module.scss';

interface Props extends FormComponentProps {
	userStore?: UserStore;
	addressesStore?: AddressesStore;
	ccStore?: CCStore;
}

const EditUserProfileComponent: React.FC<Props> = props => {
	const getAddressDetails = () => {
		const { addressDetails } = props.addressesStore!;

		if (addressDetails) {
			const { placeId, formattedAddress, addressName } = addressDetails;

			return { placeId, formattedAddress, addressName };
		}

		const formValues = props.form.getFieldsValue();
		const { userInfo } = props.userStore!;
		const formValuePlaceId = formValues[FORM_STRUCTURE.USER_ADDRESS_PLACE_ID];

		return {
			placeId: formValuePlaceId,
			formattedAddress: formValuePlaceId && userInfo && userInfo.formattedAddress,
			addressName: formValuePlaceId && userInfo && userInfo.addressName,
		};
	};

	const toApiData = (): UpdateUserProfile => {
		const formValues = props.form.getFieldsValue();
		const id = props.userStore!.user.profile.sub;
		const { paymentMethodIds } = props.ccStore!;

		return removeEmptyProperties({
			...getAddressDetails(),
			id,
			paymentMethodIds,
			password: formValues[FORM_STRUCTURE.PASSWORD],
			firstName: formValues[FORM_STRUCTURE.FIRST_NAME],
			lastName: formValues[FORM_STRUCTURE.LAST_NAME],
			emailAddress: formValues[FORM_STRUCTURE.EMAIL_ADDRESS],

			preferredCarTypeId: formValues[FORM_STRUCTURE.PREFERRED_SERVICE_TYPE],
			alternativeContactList: formValues[FORM_STRUCTURE.ALTERNATIVE_CONTACTS],
			phoneNumber: formValues[FORM_STRUCTURE.PHONE_NUMBER],
			phoneCode: formValues[FORM_STRUCTURE.PHONE_CODE],
			phoneCodeCountryId: formValues[FORM_STRUCTURE.PHONE_CODE_COUNTRY_ID],
			bookingConfirmation: formValues[FORM_STRUCTURE.BOOKING_CONFIRMATION],
			invoiceConfirmation: formValues[FORM_STRUCTURE.INVOICE_CONFIRMATION],
			calendarBookingEvent: formValues[FORM_STRUCTURE.CALENDAR_BOOKING_EVENT],
			journeyNotes: formValues[FORM_STRUCTURE.JOURNEY_NOTES],
			referenceFields: formValues[FORM_STRUCTURE.REFERENCE_FIELDS],
		});
	};
	const { isUpdateModalOpen, toggleModal, isUpdating } = props.userStore!;
	const { form } = props;

	const isCCProcesing = props.ccStore!.isPending;

	return (
		<div className={styles.editUserBtnContainer}>
			<Button size="small" onClick={toggleModal} className={styles.editUserBtn}>
				Edit
			</Button>
			{isUpdateModalOpen && (
				<Modal
					title={'Edit Profile'}
					visible
					onOk={() => {
						props.userStore!.updateUserProfile(toApiData());
					}}
					okText={'Save'}
					onCancel={toggleModal}
					isLoading={isUpdating || isCCProcesing}
					okButtonProps={{
						disabled: hasErrors(form.getFieldsError()),
					}}
					destroyOnClose
				>
					<UserProfileForm form={form} />
				</Modal>
			)}
		</div>
	);
};
const WrapperComponent = inject(({ userStore, addressesStore, ccStore }: RootStore) => ({
	userStore,
	addressesStore,
	ccStore,
}))(observer(EditUserProfileComponent));
export const EditUserProfile = Form.create({ name: 'UserProfileForm' })(WrapperComponent);
